export const pickingReportConfig = {
  MAX_ROWS_PICKING_REPORT: 5000,
  MAX_ROWS_PICKING_REPORT_HESA: 3000,
  LIMIT_PICKING_REPORT: 100000,
  ZONE_SKU_NAME: "Zona SKU",
  AGREED_AUDIT_RESULT : 'Conforme',
  NOT_AUDITED_AUDIT_RESULT : 'No auditado',
  OBSERVED_AUDIT_RESULT : 'Observado'
};
